import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import dmuRatings from "../../../../src/data/articles/cube-prospective-dominaria-united/dmu-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  dmuRatings,
  ProspectiveIntro,
  React
};